module.exports = __webpack_public_path__ + "img/bank-national-bank.1f95277a.png";